import APIService from 'services/APIService'

const api = APIService()

export const fetchWhatsNew = () => {
  return api.get('/whats-new')
}

export const fetchRecentWhatsNew = (limit = 3) => {
  return api.get(`/whats-new/recent?limit=${limit}`)
}

export const fetchWhatsNewStatus = () => {
  return api.get('/whats-new/status')
}

export const markWhatsNewSeen = () => {
  return api.post('/whats-new/seen')
}
